export const convertRewardFilterToEvoRewardType = (filterType) => {
    if (filterType === "virtual" || filterType === "sensorial") {
        return "simplified";
    }
    if (filterType === "physical") {
        return "physical";
    }
};
export const convertEvoGetPrizes = (evoPrizes) => {
    var _a;
    const { data, meta } = evoPrizes;
    const convertedPrizes = data.map((prize) => {
        var _a, _b, _c, _d, _e;
        const { presentation: { images = [], name, description }, identifier: prize_uuid, brand_name: brandName, points, custom_attributes: { color, locations = [], slug }, has_coupons, created_at, levels, usage_limit: { per_user } = {}, redeemed_times, prize_type, validity_rules = {
            time: { to: undefined, from: undefined, limited: false },
        }, } = prize;
        return {
            prize_uuid,
            name,
            brandName,
            subtitle: description !== null && description !== void 0 ? description : "",
            points,
            images,
            color: color !== null && color !== void 0 ? color : "",
            has_coupons,
            created_at,
            levels: levels !== null && levels !== void 0 ? levels : [],
            locations,
            slug,
            isAddressRequired: Boolean((_a = prize === null || prize === void 0 ? void 0 : prize.custom_attributes) === null || _a === void 0 ? void 0 : _a.is_address_required),
            prize_type,
            redeemedTimes: redeemed_times,
            usageLimit: per_user,
            time_to: (_c = (_b = validity_rules === null || validity_rules === void 0 ? void 0 : validity_rules.time) === null || _b === void 0 ? void 0 : _b.to) !== null && _c !== void 0 ? _c : undefined,
            time_from: (_e = (_d = validity_rules === null || validity_rules === void 0 ? void 0 : validity_rules.time) === null || _d === void 0 ? void 0 : _d.from) !== null && _e !== void 0 ? _e : undefined,
        };
    });
    return {
        items: convertedPrizes,
        total: (_a = meta.total) !== null && _a !== void 0 ? _a : 0,
    };
};
//# sourceMappingURL=convertEvoGetPrizes.js.map